import React from "react";
import { Link } from "react-router-dom";

// iter-61 — Global footer mounted across every marketing page (/, /features,
// /workspaces). Four semantic columns as specified in the operator brief.
// Kept in a dedicated component so a routing swap never drops the footer.

const COLUMNS = [
  {
    title: "Product Platform",
    testid: "footer-col-product",
    items: [
      { label: "Upload Engine", to: "/features" },
      { label: "Advanced Compiler", to: "/features" },
      { label: "EPUB 3.0 Standard", to: "/features" },
    ],
  },
  {
    title: "Design Typography",
    testid: "footer-col-design",
    items: [
      { label: "Crimson Pro Pack", to: "/features" },
      { label: "Georgia Trade Styles", to: "/features" },
      { label: "Widow Safeguard Lines", to: "/features" },
    ],
  },
  {
    title: "Editorial Workspaces",
    testid: "footer-col-workspaces",
    items: [
      { label: "Shared Collaboration", to: "/workspaces" },
      { label: "Activity Auditing", to: "/workspaces" },
      { label: "Tag Allocation", to: "/workspaces" },
    ],
  },
  {
    title: "Legal & Systems",
    testid: "footer-col-legal",
    items: [
      { label: "Support & FAQ", to: "/support" },
      { label: "Contact support", href: "mailto:support@bookforge360.com" },
      { label: "Terms of Use", to: "/" },
      { label: "Privacy Vault", to: "/" },
      { label: "Status PASS", to: "/" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer
      className="border-t border-[color:var(--border)] bg-[#faf9f6]"
      data-testid="site-footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {COLUMNS.map((col) => (
            <div key={col.title} data-testid={col.testid}>
              <h4 className="font-editorial text-lg mb-4">{col.title}</h4>
              <ul className="space-y-2 text-sm text-[color:var(--text-muted)]">
                {col.items.map((it) => (
                  <li key={it.label}>
                    {it.href ? (
                      <a
                        href={it.href}
                        className="link-underline hover:text-[color:var(--text)] transition-colors"
                        data-testid={`footer-link-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      >
                        {it.label}
                      </a>
                    ) : (
                      <Link
                        to={it.to}
                        className="link-underline hover:text-[color:var(--text)] transition-colors"
                        data-testid={`footer-link-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      >
                        {it.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="pt-8 border-t border-[color:var(--border)] flex flex-wrap items-center justify-between gap-4 text-xs uppercase tracking-[0.2em] text-[color:var(--text-muted)]">
          <span data-testid="footer-copyright">
            © 2026 BookForge360 · bookforge360.com · All rights reserved
          </span>
          <a
            href="https://richardleegarcia.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[color:var(--primary)] transition-colors"
            data-testid="footer-parent-company-link"
          >
            Managed and Operated by Richard Lee Garcia Groups, LLC.
          </a>
          <span className="hidden sm:inline">
            Professional Typography, Automated
          </span>
        </div>
      </div>
    </footer>
  );
}
